export default __webpack_public_path__ + "static/media/ic-transfer-in-transit-secondary.b4db4c73.svg";